import {PopulateDataHandler} from "../../../infrastructure/handlers/populate-data-handler";
import {PREDICTION_WIDGET} from "../predictions-widget.consts";
import type {PredictionsWidgetController} from "../predictions-widget.controller";
import {PredictionViewModel} from "../../../domain/full-game/models/prediction/prediction-view-model";
import {PredictionDomainModel} from "../../../domain/full-game/models/prediction/prediction.domain-model";
import {PredictionSelectionModel} from "../../../infrastructure/models/schema/prediction-selection.model";
import type {PlayerBetPredictionDomainModel} from "../../../domain/full-game/models/player-bet-prediction/player-bet-prediction.domain-model";
import {PlayerBetPredictionViewModel} from "../../../domain/full-game/models/player-bet-prediction/player-bet-prediction.view-model";
import {PredictionsSelectionsManager} from "../../../core/managers/predictions-selections.manager";
import {BaseComponentLifecycleEventHandler} from "../../../infrastructure/handlers/base-component-lifecycle-event-handler";
import type {PredictionsWidgetState} from "../models/predictions-widget.state";
import {EXTRA_LINKS_CONTEXTS, GAME_STATUSES} from "../../../core/app/consts";
import {PredictionWidgetMainCardsModel} from "../models/cards/prediction-widget.main-cards.model";
// import {COMPONENT_STATES} from "../../../core/consts";

export class PredictionWidgetPopulateDataHandler extends PopulateDataHandler {
  controller: PredictionsWidgetController;
  state: PredictionsWidgetState;
  type = PREDICTION_WIDGET.ACTION_TYPES.populateData;

  static injectables = [...BaseComponentLifecycleEventHandler.injectables, PredictionsSelectionsManager]

  constructor(predictionsSelectionsManager: PredictionsSelectionsManager) {
    super();

    this.predictionsSelectionsManager = predictionsSelectionsManager;
  }

  async action(params) {
    const selectedOddsType = this.state.appState.currentOddsType;
    this.state.predictions = this.createPredictions(params.dataSource, selectedOddsType);
    this.state.playersBetsPredictions = this.createPlayersBetsPredictions(params.dataSource, selectedOddsType);

    if(!params.isDelta) {
      this.state.currentContext = new PredictionWidgetMainCardsModel(this.state.predictions, 0)
    }

    await super.action(params)
  }

  createPredictions(dataSource, selectedOddsType): Array<PredictionViewModel> {
    const predictions: Array<PredictionViewModel> = dataSource?.game?.predictions?.map((prediction: PredictionDomainModel, index: Number) => {
      const selection: PredictionSelectionModel = this.predictionsSelectionsManager.selections.find((selection: PredictionSelectionModel) => selection.predictionId === prediction.id);

      return new PredictionViewModel(index, prediction, selection?.num, selectedOddsType, dataSource?.game.statusGroup, dataSource?.game.id, this.context(dataSource));
    });

    return predictions;
  }

  createPlayersBetsPredictions(dataSource, selectedOddsType): Array<PredictionViewModel> {
    const predictions: Array<PredictionViewModel> = dataSource?.game?.playersBetsPredictions?.map((prediction: PlayerBetPredictionDomainModel, index: Number) => {
      const selection: PredictionSelectionModel = this.predictionsSelectionsManager.selections.find((selection: PredictionSelectionModel) => selection.predictionId === prediction.id);

      return new PlayerBetPredictionViewModel(index, prediction, selection?.num, selectedOddsType, dataSource?.game.statusGroup, dataSource?.game.id, this.context(dataSource));
    });

    return predictions;
  }

  context(params): EXTRA_LINKS_CONTEXTS {
    let context: EXTRA_LINKS_CONTEXTS = EXTRA_LINKS_CONTEXTS.predictions;

    if (params.game.gameStatus === GAME_STATUSES.scheduled) {
      context = EXTRA_LINKS_CONTEXTS.gameCenterPredictions;
    }
    if (params.game.gameStatus === GAME_STATUSES.started) {
      context = EXTRA_LINKS_CONTEXTS.predictions;
    }

    return context;
  }
}
